import React, { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import { Icon } from '@cld/icon';
import { typography } from '@cld/typography';

const Root = styled.div`
  padding: ${globalTheme.spacing.md} ${globalTheme.spacing.lg};
  display: flex;
  background-color: ${globalTheme.palette.backgroundAlt};
`;

const Title = styled.div`
  ${typography.md.regular};
`;

const Contents = styled.div`
  flex: 1;
  margin: 0 ${globalTheme.spacing.md};
`;

const CloseButton = styled(Icon).attrs({ name: 'close', size: 'lg' })`
  color: ${globalTheme.palette.contrastHigh};
  cursor: pointer;
`;

export interface HeaderProps {
  title: string,
  onClose: () => void,
  children?: ReactNode,
}

export const Header: FC<HeaderProps> = ({ title, onClose, children }) => (
  <Root>
    <Title data-test="layout-header">{title}</Title>
    <Contents>{children}</Contents>
    <CloseButton onClick={onClose} data-test="layout-close" />
  </Root>
);
